//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import codeHighlight from './components/codeHighlight';
export default {
  name: 'app',
  components: {
    codeHighlight
  },
  data() {
    return {
      share: {
        twitter: {
          size: "2x",
          label: "Custom label!",
          round: true,
        },
        linkedin: {
          size: "2x",
          color: "#333",
          backgroundColor: "yellow",
        },
        facebook: {
          size: "3x",
          dark: true
        },
        whatsapp: {
          size: "2x",
          dense: true,
          outline: true,
          color: 'green',
        },
      },
      iconConfig: {
        twitter: {
          icon: true,
          size: "sm",
          color: "#333",
          round: true,
          backgroundColor: 'yellow'
        },
        linkedin: {
          icon: true,
          size: "lg",
          outline: true,
          round: true,
          
        },
        facebook: {
          icon: true,
          size: "2x",
          outline: true,
          round: true
        },
        whatsapp: {
          icon: true,
          size: "3x",
          outline: true,
          round: true
        },
        reddit: {
          icon: true,
          size: "4x",
          outline: true,
          round: true
        },
      },
      htmlIconColor: '#e44d26',
      scriptIconColor: '#f8af00',
      platformList: [
        {
          name: 'Twitter',
          id: 'twitter'
        },
        {
          name: 'LinkedIn',
          id: 'linkedin'
        },
        {
          name: 'Facebook',
          id: 'facebook'
        },
        {
          name: 'Whatsapp',
          id: 'whatsapp'
        },
        {
          name: 'Reddit',
          id: 'reddit'
        },
      ],
      propsList: [
        {
          name: 'text',
          type: 'String',
          default: '""',
          description: 'Caption',
        },
        {
          name: 'url',
          type: 'String',
          default: '""',
          description: 'URL to share',
        },
        {
          name: 'width',
          type: 'Number',
          default: '600',
          description: 'Width of the share window',
        },
        {
          name: 'height',
          type: 'Number',
          default: '600',
          description: 'Height of the share window',
        },
        {
          name: 'dense',
          type: 'Boolean',
          default: 'false',
          description: 'Dense button styling',
        },
        {
          name: 'dark',
          type: 'Boolean',
          default: 'false',
          description: 'Dark button styling',
        },
        {
          name: 'targets',
          type: 'Array',
          default: '[]',
          description: 'Specify social media targets, defaults to all available targets',
        },
        {
          name: 'icons',
          type: 'Boolean',
          default: 'false',
          description: 'Use icons as buttons',
        },
        {
          name: 'outline',
          type: 'Boolean',
          default: 'false',
          description: 'Outline button styling',
        },
        {
          name: 'round',
          type: 'Boolean',
          default: 'false',
          description: 'Round button styling for icons',
        },
        {
          name: 'iconSize',
          type: 'String',
          default: 'lg',
          description: 'Specify icon size. See [size chart](#sizeChart) below',
        },
        {
          name: 'shareConfig',
          type: 'Object',
          default: '{<br><br>linkedin: {},<br><br>twitter: {},<br><br>facebook: {},<br><br>whatsapp: {},<br><br>reddit: {},<br><br>}',
          description: 'Advanced configuration for target specific styling',
        },
      ],
      eventsList: [
        {
          name: 'clicked',
          description: 'Event that is emitted when a share button is clicked',
          value: 'Returns social media platform which was clicked. E.g. ["twitter"]',
        },
      ],
      slotsList: [
        {
          name: '`${platform}-icon`',
          description: 'Custom icon for platform',
        },
        {
          name: '`${platform}-label`',
          description: 'Custom label for platform',
        },
      ],
      content: [
        {
          label: 'Features',
          value: 'features',
        },
        {
          label: 'Installation',
          value: 'installation',
        },
        {
          label: 'Usage',
          value: 'usage',
        },
        {
          label: 'Supported platforms',
          value: 'supported-platforms',
        },
        {
          label: 'API',
          value: 'api',
          children: [
            {
              label: 'Props',
              value: 'api-props',
            },
            {
              label: 'Events',
              value: 'api-events',
            },
            {
              label: 'Slots',
              value: 'api-slots',
            },
          ],
        },
        {
          label: 'Examples',
          value: 'examples',
          children: [
            {
              label: 'Default',
              value: 'example-default',
            },
            {
              label: 'Global configs',
              value: 'example-global-configs',
            },
            {
              label: 'Targets',
              value: 'example-targets',
            },
            {
              label: 'Dark',
              value: 'example-dark',
            },
            {
              label: 'Dense',
              value: 'example-dense',
            },
            {
              label: 'Outlined',
              value: 'example-outlined',
            },
            {
              label: 'Button configs',
              value: 'example-button-configs',
            },
            {
              label: 'Outlined icons',
              value: 'example-outlined-icons',
            },
            {
              label: 'Rounded icons',
              value: 'example-rounded-icons',
            },
            {
              label: 'Icon configs',
              value: 'example-icon-configs',
            },
            {
              label: 'Using slots',
              value: 'example-using-slots',
            },
          ],
        },
      ],
    }
  },
  computed: {
    pageURL () {
      return window.location.href
    }
  },
  mounted() {
    window.addEventListener('hashchange', () => {
        window.scrollTo(window.scrollX, window.scrollY - 100);
    });
  },
  beforeDestroy() {
    window.removeEventListener('hashchange');
  },
}
